exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.filter {\n  cursor: pointer; }\n  .filter.on {\n    font-weight: bold; }\n    .filter.on:after {\n      content: \"\\2193\"; }\n    .filter.on.desc:after {\n      content: \"\\2191\"; }\n\ntable {\n  table-layout: fixed; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/stats/last-transactions/last-transactions/last-transactions.component.scss
// module id = ../../../../../src/app/pages/dashboard/stats/last-transactions/last-transactions/last-transactions.component.scss
// module chunks = main